<template>
	<div style="width: 100%">
			Listado de sitios...
	</div>
</template>

<script>

//import Sitio from '@/components/sitios/sitio.vista'

export default {
  name: 'sitios-vista',

  data: () => ({
		//cargando: true,
		sitio: null
		//sitios: [],
	}),

	components: {
		//Sitio
	},

	watch: {
		$route(to, from) {
			//if (this.cargando || (!to.params.sitio && !this.sitio) || (this.sitio && to.params.sitio === this.sitio.identificador)) {
			//	return
			//}

			//this.actualizarSitio(to.params.sitio)
		},
		/*cargando(val) {
			if (val) {
				return
			}

			this.actualizarSitio(this.$route.params.sitio)
		}*/
	},

	mounted: function() {
		//this.$root.firestore.collection('cuentas').doc(this.$root.cuenta.identificador).collection('sitios').onSnapshot( snapshot => {
		//	this.cargando = false
		//	this.$root.manejarCambiosFirebase(this.sitios, snapshot)
    //})
	},

	methods: {
		/*actualizarSitio: function(identificador) {
			if (identificador) {
				for (let s of this.sitios) {
					if (s.identificador === identificador) {
						this.sitio = s
						break
					}
				}
			} else {
				this.sitio = {}
			}
		}*/
		/*actualizarSitio: function(identificador) {
			if (identificador === this.sitio.identificador) {
				return
			}

			if (!identificador) {
				this.sitio = null
				return
			}

			for (let s of this.$root.sitios) {
				if (s.identificador === identificador) {
					this.sitio = s
					break
				}
			}

			if (!this.sitio || !this.sitio.identificador || identificador !== this.sitio.identificador) {
				this.$root.error('[4392] Ocurrió un error. Recarga la página e intenta de nuevo.')
			}
		}*/
	}
};


</script>